/**
 * 文章分类 / 子分类展示名英文映射。
 * 数据库与筛选仍用中文 key；仅界面展示时替换。
 * 未收录的名称在英文站保持原文。
 */
export const categoryLabelsEn = {
  全部: 'All',
  小工具: 'Utilities',
  办公软件: 'Office',
  开发工具: 'Dev tools',
  系统工具: 'System',
  设计工具: 'Design',
  效率工具: 'Productivity',
  工具: 'Tools',
  软件: 'Software',
  入门教程: 'Beginner',
  实战项目: 'Projects',
  进阶指南: 'Advanced',
  学习资源: 'Learning',
  开源项目: 'Open source',
  书籍推荐: 'Books',
  前端: 'Frontend',
  性能: 'Performance',
  教程: 'Tutorials',
  资源: 'Resources',
  资讯: 'News',
  技术: 'Tech',
  技术文章: 'Tech articles',
  软件推荐: 'Software picks',
  教程文章: 'Tutorials',
  资源分享: 'Resources',
  资讯动态: 'News',
  未分类: 'Uncategorized',
  // 常见技术标签 / 分类
  工程化: 'Engineering',
  用户体验: 'UX',
  截图: 'Screenshot',
  搜索: 'Search',
  预览: 'Preview',
  笔记: 'Notes',
  终端: 'Terminal',
  编辑器: 'Editor',
  浏览器: 'Browser',
  网络: 'Network',
  安全: 'Security',
  数据库: 'Database',
  运维: 'Ops',
  算法: 'Algorithms',
  框架: 'Framework',
  组件: 'Components',
  动画: 'Animation',
  移动端: 'Mobile',
  小程序: 'Mini program',
  // 文章卡片 / 详情常见标签（展示用，筛选仍用中文）
  照片: 'Photos',
  开源: 'Open source',
  搭建: 'Setup',
  自建: 'Self-hosted',
  自托管: 'Self-hosted',
  私人: 'Private',
  隐私: 'Privacy',
  漂白去底: 'Remove background',
  加深文字: 'Darken text',
  直接打印: 'Direct print',
  去底: 'Cutout',
  抠图: 'Cutout',
  去背景: 'Background removal',
  证件照: 'ID photo',
  打印: 'Print',
  相册: 'Gallery',
  备份: 'Backup',
  同步: 'Sync',
  免费: 'Free',
  付费: 'Paid',
  推荐: 'Picks',
  评测: 'Review',
  安装: 'Install',
  配置: 'Config',
  部署: 'Deploy',
  图片: 'Images',
  视频: 'Video',
  音频: 'Audio',
  文档: 'Docs',
  转换: 'Convert',
  压缩: 'Compress',
  加密: 'Encrypt',
  优化: 'Optimize',
  缓存: 'Cache',
  微信: 'WeChat',
  服务器: 'Server',
  家庭: 'Home',
  家用: 'Home use',
  海报: 'Poster',
  设计: 'Design',
  排版: 'Layout',
  字体: 'Fonts',
  水印: 'Watermark',
  二维码: 'QR code',
  条码: 'Barcode',
  翻译: 'Translate',
  英语: 'English',
  中文: 'Chinese',
  博客: 'Blog',
  建站: 'Site building',
  域名: 'Domain',
  备案: 'ICP filing',
  脚本: 'Scripts',
  批处理: 'Batch',
  自动化: 'Automation',
  监控: 'Monitoring',
  日志: 'Logs',
  摄像头: 'Camera',
  录像: 'Recording',
  带宽: 'Bandwidth',
  电池: 'Battery',
  电工: 'Electrical',
  线缆: 'Cabling',
  计算器: 'Calculator',
  单位: 'Units',
  科学: 'Science',
  房间: 'Room',
  面积: 'Area',
  生活: 'Life',
  健康: 'Health',
  日历: 'Calendar',
  农历: 'Lunar calendar',
  孕期: 'Pregnancy',
  手机: 'Phone',
  归属地: 'Carrier lookup',
  身份证: 'ID card',
  高校: 'University',
  国家: 'Country',
  血型: 'Blood type',
  学生: 'Students',
  评语: 'Comments',
  合同: 'Contract',
  报价: 'Quote',
  收据: 'Receipt',
  名片: 'Card',
  点餐: 'Ordering',
  礼薄: 'Gift book',
  任务: 'Tasks',
  活码: 'Dynamic QR',
  人声: 'Vocals',
  局域网: 'LAN',
  传输: 'Transfer',
  简历: 'Resume',
  分享: 'Share',
  下载: 'Download',
  源码: 'Source',
  经验: 'Notes',
  踩坑: 'Pitfalls',
  对比: 'Compare',
  替代: 'Alternative',
  登录: 'Sign-in',
  账号: 'Account',
  路由: 'Router',
  交换机: 'Switch',
  会员: 'Membership',
  教程: 'Tutorial',
  入门: 'Beginner',
  进阶: 'Advanced',
  实战: 'Hands-on',
  汉信码: 'Han Xin Code',
  条形码: 'Barcode',
  扫描: 'Scan',
  识别: 'Recognize',
  生成: 'Generate',
  合并: 'Merge',
  拆分: 'Split',
  裁剪: 'Crop',
  旋转: 'Rotate',
  拼接: 'Stitch',
  九宫格: '9-grid',
  图标: 'Icon',
  透明: 'Transparent',
  本地: 'Local',
  浏览器: 'Browser',
  无需上传: 'No upload',
  实用: 'Practical',
  效率: 'Productivity',
  办公: 'Office',
  开发: 'Dev',
  运维: 'Ops',
  前端: 'Frontend',
  后端: 'Backend',
  全栈: 'Full stack',
  安全: 'Security',
  网络: 'Network'
}

export const articleTypeLabelKeys = {
  tech: 'articles.titleTech',
  software: 'articles.titleSoftware',
  tutorial: 'articles.titleTutorial',
  resource: 'articles.titleResource',
  news: 'articles.titleNews'
}
